module.exports = __webpack_public_path__ + "img/mobile/General/spelser@3x.png?1.0.17";